import { createFileRoute } from '@tanstack/react-router';
import { NotificationsScreen } from '@/features/notifications/NotificationsScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';
import { q } from '@/lib/queries.ts';

export const Route = createFileRoute('/_app/notifications')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.prefetchInfiniteQuery(q.notificationsInfinite()),
  component: NotificationsScreen,
});
